var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "More_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 16,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#More_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIzNjZfNjQ1NCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iNiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjQiPgo8cGF0aCBkPSJNMTQgMTBDMTUuMTA0NiAxMCAxNiA5LjEwNDU3IDE2IDhDMTYgNi44OTU0MyAxNS4xMDQ2IDYgMTQgNkMxMi44OTU0IDYgMTIgNi44OTU0MyAxMiA4QzEyIDkuMTA0NTcgMTIuODk1NCAxMCAxNCAxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDEwQzkuMTA0NTcgMTAgMTAgOS4xMDQ1NyAxMCA4QzEwIDYuODk1NDMgOS4xMDQ1NyA2IDggNkM2Ljg5NTQzIDYgNiA2Ljg5NTQzIDYgOEM2IDkuMTA0NTcgNi44OTU0MyAxMCA4IDEwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIgMTBDMy4xMDQ1NyAxMCA0IDkuMTA0NTcgNCA4QzQgNi44OTU0MyAzLjEwNDU3IDYgMiA2QzAuODk1NDMgNiAwIDYuODk1NDMgMCA4QzAgOS4xMDQ1NyAwLjg5NTQzIDEwIDIgMTBaIiBmaWxsPSJibGFjayIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjM2Nl82NDU0KSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iIzE0MTYxQSIvPgo8L2c+Cjwvc3ZnPgo=";